// src/components/common/ViewToggle.jsx - UPDATED VERSION

import React from 'react';
import { Eye, Settings } from 'lucide-react';

export const ViewToggle = ({ 
  viewMode, 
  onToggle, 
  user,
  hasManagementAccess,
  viewConfig = {},
  className = '',
  position = 'bottom-right'
}) => {
  const { publicViewLabel = 'Public View', managementViewLabel = 'Management' } = viewConfig;

  const positionClasses = {
    'bottom-right': 'bottom-6 right-6',
    'bottom-left': 'bottom-6 left-6',
    'top-right': 'top-6 right-6',
    'top-left': 'top-6 left-6'
  };

  if (!hasManagementAccess) {
    return null;
  }

  // Determine button state based on current view mode
  const getButtonState = () => {
    if (viewMode === 'public') {
      return {
        icon: Settings,
        label: managementViewLabel,
        color: 'blue',
        tooltip: 'Switch to management view'
      };
    } else {
      return {
        icon: Eye,
        label: publicViewLabel,
        color: 'green',
        tooltip: 'Switch to public view'
      };
    }
  };

  const buttonState = getButtonState();
  const colorClasses = {
    blue: 'group-hover:text-blue-600',
    green: 'group-hover:text-green-600'
  };

  return (
    <div className={`fixed ${positionClasses[position]} z-40 ${className}`}>
      <div className="bg-white rounded-full shadow-lg border border-gray-200 overflow-hidden">
        <button
          onClick={onToggle}
          title={buttonState.tooltip}
          className="flex items-center gap-3 px-6 py-3 hover:bg-gray-50 transition-colors group"
        >
          <buttonState.icon 
            className={`h-5 w-5 text-gray-600 transition-colors ${colorClasses[buttonState.color]}`}
          />
          <span className="text-sm font-medium text-gray-700 transition-colors group-hover:text-gray-900">
            {buttonState.label}
          </span>
        </button>
      </div>
    </div>
  );
};